const RaporalTheme = {
    images : {
        loginLogo: "/img/raporal/login-logo.png",
        whiteLogo: "/img/raporal/login-logo.png",
        favicon: "/img/raporal/favicon.ico",
        leftMenuLogo: "/img/raporal/logo-only.png",

        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image"
    },
    css: [
        "/themes/raporal/raporal.css"
    ],
    strings: {
        title: "Stec, é inspiração!"
    }
}

export default RaporalTheme;